/**
 * Utility for managing user's default homepage preference
 * Stores preference in localStorage with profile-specific keys
 */

const PREFERENCE_KEY_PREFIX = 'homepage_preference_';

/**
 * Get the default homepage preference for a user/profile
 * @param {string} userId - User ID or profile ID
 * @returns {string} - 'movies', 'series', or 'live'
 */
export const getHomepagePreference = (userId) => {
  if (!userId) return 'movies'; // Default to Movies
  
  try {
    const preference = localStorage.getItem(`${PREFERENCE_KEY_PREFIX}${userId}`);
    if (preference && ['movies', 'series', 'live'].includes(preference)) {
      return preference;
    }
  } catch (error) {
    console.error('Error getting homepage preference:', error);
  }
  
  return 'movies'; // Default fallback
};

/**
 * Set the default homepage preference for a user/profile
 * @param {string} userId - User ID or profile ID
 * @param {string} preference - 'movies', 'series', or 'live'
 */
export const setHomepagePreference = (userId, preference) => {
  if (!userId) return;
  
  if (!['movies', 'series', 'live'].includes(preference)) {
    console.error('Invalid homepage preference:', preference);
    return;
  }
  
  try {
    localStorage.setItem(`${PREFERENCE_KEY_PREFIX}${userId}`, preference);
  } catch (error) {
    console.error('Error setting homepage preference:', error);
  }
};

/**
 * Get the route path for a homepage preference
 * @param {string} preference - 'movies', 'series', or 'live'
 * @returns {string} - Route path
 */
export const getHomepageRoute = (preference) => {
  switch (preference) {
    case 'series':
      return '/series';
    case 'live':
      return '/live-tv';
    case 'movies':
    default:
      return '/'; // Movies is the default homepage
  }
};

